import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/$tenant/')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/$tenant/overview', params: { tenant: params.tenant }, replace: true });
  },
});
